export default "__VITE_ASSET__BZBpL64V__"